import { Grid } from '@material-ui/core';
import { Colors } from 'library';
import React, { ReactNode } from 'react';

export default function AmbassadorPageLayout({ children }: { children?: ReactNode | ReactNode[] }) {
    return (
        <div
            style={{
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: Colors.lightTurq,
                paddingBottom: 100,
            }}
        >
            <Grid
                item
                lg={6}
                sm={8}
                xs={12}
                style={{ paddingBottom: 40, paddingTop: 40, backgroundColor: Colors.white, flexGrow: 1 }}
            >
                <div style={{ marginLeft: 40, marginRight: 40 }}>{children}</div>
            </Grid>
        </div>
    );
}
